import styled from "styled-components";
import { Button } from "@material-ui/core"; 

export const FeaturesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ActionsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center; 
  gap: 16px; 
  margin-bottom: 2rem; 
  margin-top: 1rem;
`;

export const TextButton = styled(Button).attrs({
  variant: "contained",
  disableElevation: true
})`
  && {
    font-weight: 600;
    text-transform: none; 
    font-size: 13px;
    padding: 8px 18px;
    border-radius: 5px;
    transition: all 0.2s ease-in-out;
    border: 1px solid transparent;

    background-color: ${props => props.isDelete ? '#fff5f5' : '#000'}; 
    color: ${props => props.isDelete ? '#e53e3e' : '#fff'}; 
    border-color: ${props => props.isDelete ? '#fed7d7' : '#000'};

    svg {
      font-size: 18px;
      margin-right: 8px;
    }

    &:hover {
      background-color: ${props => props.isDelete ? '#e53e3e' : '#000'};
      color: #fff;
      border-color: transparent;
    }
  }
`;

export const SectionHeader = styled.h4`
  font-size: 0.95rem;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
`;